/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { get } from 'lodash';

const __vue_script__ = {
    name: 'PendingRegistrations',

    props: {
        event: {
            type: Object,
            required: true
        }
    },

    data() {
        return {
            enabled: false,
            pendingPath: null,
            pendingRegs: 0
        };
    },

    async created() {
        try {
            const regModule = this.$services.blueprint.getModuleByName('registration');
            const paxModule = this.$services.blueprint.getModuleByName('participants');

            if (!paxModule || !regModule) {
                console.info('[PendingRegistrations] Required modules not found');
                return;
            }

            const config = await this.$services.pax.getRegistrationConfig(this.event._id, 5000);
            this.enabled = get(config, 'settings.manual_approval');

            if (!this.enabled) {
                return;
            }

            const path = get(paxModule, 'controllers.self-registration-requests.route');
            if (path) {
                this.pendingPath = path.replace(':eventId', this.event._id);
            }

            const { pendingRequests } = await this.$services.appScripts.callAppScript(this.event._id, 'public-login/stats');
            this.pendingRegs = pendingRequests;

        } catch (error) {
            console.error('[PendingRegistrations] Could not load registration module', error.message);
        }
    }
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.enabled)?_c('div',{staticClass:"pending-registrations links"},[_c('span',[_c('i',{staticClass:"ic-clock"}),_vm._v(_vm._s(_vm.$t('registration.analytics.pending_registrations')))]),(_vm.pendingRegs > 0)?_c('div',{staticClass:"pending"},[_c('span',{staticClass:"count"},[_vm._v(_vm._s(_vm.pendingRegs))]),_vm._v(_vm._s(_vm.$tc('registration.analytics.pending_users', [_vm.pendingRegs])))]):_c('div',{staticClass:"no-pending"},[_vm._v(_vm._s(_vm.$t('registration.analytics.no_pending_users')))]),(_vm.pendingPath && _vm.pendingRegs > 0)?_c('div',{staticClass:"link"},[_c('a',{attrs:{"href":_vm.pendingPath}},[_vm._v(_vm._s(_vm.$t('registration.analytics.to_approval_page')))])]):_vm._e()]):_vm._e()}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "PendingRegistrations.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__